(function () {
    'use strict';

    angular
        .module('procedureControllers')
        .controller('ProcedureSectionListEditController', Controller);

    Controller.$inject = ['$rootScope', '$scope', '$state', '$modal', '$q', 'procedureService', 'permissionService', 'notificationService', 'modalService', '$timeout', 'procedure', 'sectionBlockLookups'];

    function Controller($rootScope, $scope, $state, $modal, $q, procedureService, permissionService, notificationService, modalService, $timeout, procedure, sectionBlockLookups) {

        $scope.procedure = procedure;
        $scope.sectionBlockLookups = sectionBlockLookups;
        $scope.canEditProcedure = permissionService.hasPermission('ProceduresManagement', 'Procedure', 'Edit', procedure);
        $scope.isInViewMode = false;

        // Scroll to top when loading the view
        window.scrollTo(0, 0);

        $scope.ctxtCtrl = {
            isEditing: false,
            inEditSectionBlock: null,

            legalEntities: '',
            locations: '',

            // True when user has unsaved changes in a section
            hasSectionChanged: false,

            // Options for the re-ordering of section blocks
            sortableOptions: {
                animation: 250,
                filter: '.add-child-section',
                handle: '.drag-handle',
                disabled: this.isEditing,
                onStart: function (event) {
                    if ($scope.ctxtCtrl.isEditing) {
                        event.originalEvent.preventDefault();
                    }
                    $scope.ctxtCtrl.isEditing = true;
                },
                onEnd: function () {
                    $scope.ctxtCtrl.isEditing = false;
                },
                onUpdate: updateSectionListOrder
            },

            canEditApprovers: $scope.procedure.MetadataBlock.ProcedureType.Value !== 'Reference-Document',
            canEditAccessRights: $scope.procedure.MetadataBlock.ProcedureType.Value === 'Reference-Document',

            // Active lang, might be changed in different places, initializes in english
            langAttr: null, // Default set in initLanguage
            lang: 'EN',

            // True when MetadataBlock needs to be reviewed
            metadataToReview: false,

            // Sections that need to request a review
            sectionsToRequestReview: [],

            canPublish: false,
            isPublishing: false

        };

        // Add Section
        $scope.addSection = function (parentSection, $event) {
            if ($scope.ctxtCtrl.isEditing) $scope.cancelEdition();

            // Prevent the click on the Section Box that triggers editing
            if ($event) $event.stopPropagation();

            $scope.ctxtCtrl.isEditing = true;
            var newSectionBlock = {
                _isEditing: true,
                _isEditable: false,
                Depth: 0
            };

            if (parentSection) {
                var nextSiblingIndex = getNextSiblingIndex(parentSection);
                if (nextSiblingIndex === -1) {
                    nextSiblingIndex = $scope.procedure.SectionBlocks.length;
                }

                newSectionBlock.Depth = parentSection.Depth + 1;
                $scope.procedure.SectionBlocks.splice(nextSiblingIndex, 0, newSectionBlock);
            } else {
                $scope.procedure.SectionBlocks.push(newSectionBlock);
            }
            $scope.ctxtCtrl.inEditSectionBlock = newSectionBlock;

            scrollEditedSectionIntoView();
        };

        // Edit Section Block
        $scope.editSectionBlock = function (sectionBlock) {
            if (!$scope.canEditProcedure || $scope.ctxtCtrl.hasSectionChanged) return false;

            if (sectionBlock._isToReview || sectionBlock._isToDelete) {
                openReviewModal(sectionBlock);
                return;
            }

            if ($scope.ctxtCtrl.isEditing) $scope.cancelEdition();

            $scope.ctxtCtrl.isEditing = true;
            $scope.ctxtCtrl.inEditSectionBlock = sectionBlock;
            sectionBlock._isEditing = true;
            sectionBlock._isEditable = false;

            scrollEditedSectionIntoView();
        };

        // Get Procedure Status Value
        $scope.getProcedureStatusValue = function () {
            var status = _.get($scope, 'procedure.ProgressStatus.Value', null);
            return status === 'Published' ? status : 'Draft';
        };

        // Language Changed
        $scope.setLanguage = function (langAttr) {
            $scope.ctxtCtrl.langAttr = langAttr;
            $scope.ctxtCtrl.lang = langAttr.Value;
        };

        // Called when user saved or cancelled the section modifications
        $scope.finishedEditing = function (updatedSectionBlock) {
            var editedBlock = updatedSectionBlock || $scope.ctxtCtrl.inEditSectionBlock;

            // Visual indicator of the newly added section block, combined with CSS animation
            if (editedBlock.SectionBlockID) {
                var finishedEditingSectionBlock = editedBlock;
                finishedEditingSectionBlock._justFinishedEditing = true;
                $timeout(function () {
                    finishedEditingSectionBlock._justFinishedEditing = false;
                }, 3000);
            }

            if (updatedSectionBlock) {
                var editIndex = _.findIndex($scope.procedure.SectionBlocks, {
                    _isEditing: true
                });
                $scope.procedure.SectionBlocks[editIndex] = updatedSectionBlock;
            }

            editedBlock._isEditable = $scope.canEditProcedure;
            $scope.ctxtCtrl.inEditSectionBlock._isEditing = false;
            $scope.ctxtCtrl.isEditing = false;
            $scope.ctxtCtrl.inEditSectionBlock = null;
            $scope.ctxtCtrl.hasSectionChanged = false;

            initSectionBlock(editedBlock);
        };

        $scope.canRequestReviewSection = function (section) {
            return section._canRequestReview;
        };

        $scope.requestReviewSection = function ($event, section) {
            // Prevent the click on the Section Box that triggers editing
            if ($event) $event.stopPropagation();
            section._isEditable = false;

            procedureService
                .requestReviewSectionBlock(
                    $scope.procedure.MetadataBlock.ProcedureType.Value,
                    $scope.procedure.ProcedureID,
                    section.SectionBlockID)
                .then(function (updatedSection) {
                    var idx = _.findIndex($scope.procedure.SectionBlocks, {
                        SectionBlockID: updatedSection.SectionBlockID
                    });

                    initSectionBlock(updatedSection);
                    $scope.procedure.SectionBlocks[idx] = updatedSection;
                });
        };

        // Go to Edit Reviewers view
        $scope.editReviewers = function () {
            $state.go('procedure.edit.reviewers');
        };

        // Go to Edit Access rights view
        $scope.editAccessRights = function () {
            $state.go('procedure.edit.accessRights');
        };

        // Go to metadata view
        $scope.viewProcedureDetails = function () {
            $state.go('procedure.edit.metadata');
        };

        // Cancel Edition
        $scope.cancelEdition = function () {

            // Block already existing on the server
            if ($scope.ctxtCtrl.inEditSectionBlock.SectionBlockID) {
                $scope.finishedEditing();
            } else {

                // Not yet created
                $scope.procedure.SectionBlocks = _.reject($scope.procedure.SectionBlocks, {
                    _isEditing: true
                });

                $scope.finishedEditing();
            }
        };

        // Remove Section Block
        $scope.removeSectionBlock = function (sectionToDelete) {
            $scope.procedure.SectionBlocks = _.reject($scope.procedure.SectionBlocks, {
                SectionBlockID: sectionToDelete.SectionBlockID
            });

            updateRequestReviewForSection(sectionToDelete);
        };

        // Return list of Section Block IDs in order
        $scope.getAllSectionBlockIDs = function () {
            var idList = [];
            _.each($scope.procedure.SectionBlocks, function (section) {
                idList.push(section.SectionBlockID ? section.SectionBlockID : -1);
            });
            return idList;
        };

        // Can dedent section block
        $scope.canDedentSectionBlock = function (sectionBlock) {
            return sectionBlock._isEditable && sectionBlock.Depth > 0;
        };

        // Can indent section block
        $scope.canIndentSectionBlock = function (sectionBlock, index) {
            return sectionBlock._isEditable
                && index > 0
                && $scope.procedure.SectionBlocks[index - 1].Depth >= sectionBlock.Depth;
        };

        // Indent Section Block
        $scope.indentSectionBlock = function (sectionBlock, $event) {
            updateSectionBlockLevel(sectionBlock, sectionBlock.Depth + 1, $event);
        };

        // Dedent Section Block
        $scope.dedentSectionBlock = function (sectionBlock, $event) {
            updateSectionBlockLevel(sectionBlock, sectionBlock.Depth - 1, $event);
        };

        // Get next Section Block
        $scope.getNextSectionBlock = function (sectionBlock) {
            var index = _.findIndex($scope.procedure.SectionBlocks, { SectionBlockID: sectionBlock.SectionBlockID });

            if (index === $scope.procedure.SectionBlocks.length - 1 || index < 0) return null;

            return $scope.procedure.SectionBlocks[index + 1];
        };

        // Scroll to a section block with a potential offset before
        $scope.scrollToSection = function (sectionBlock, offSetTop) {
            offSetTop = offSetTop ? offSetTop : 0;

            var scrollTop = jQuery('#section-' + _.get(sectionBlock, 'SectionBlockID', '')).offset().top;
            jQuery('html, body').animate({
                scrollTop: scrollTop - offSetTop
            });
        };

        // Should the attachment be displayed
        $scope.isAttachmentVisible = function (attachment) {
            if ($scope.ctxtCtrl.lang === 'EN') {
                return attachment.LanguageID === $scope.ctxtCtrl.langAttr.LookupAttributeValueID;
            }

            return !!attachment.TitleFR;
        };

        // Go to View mode
        $scope.goToViewMode = function () {
            // Redirect to published or working copy
            var view = $scope.procedure.IsPublished ? 'procedure.viewPublished' : 'procedure.view';

            $state.go(view, {
                    ProcedureType: $scope.procedure.MetadataBlock.ProcedureType.Value,
                    ProcedureCode: $scope.procedure.MetadataBlock.ProcedureCode.Code
                }, {
                    location: 'replace'
                }
            );
        };

        // Publish
        $scope.publish = function () {
            if ($scope.ctxtCtrl.isPublishing) return;

            $scope.ctxtCtrl.isPublishing = true;

            procedureService
                .publishProcedure(
                    $scope.procedure.MetadataBlock.ProcedureType.Value,
                    $scope.procedure.ProcedureID)
                .then(function () {
                    $state.reload();
                })
                .finally(function () {
                    $scope.ctxtCtrl.isLoading = false;
                });
        };

        function init() {
            $scope.ctxtCtrl.legalEntities = _.join(_.map($scope.procedure.MetadataBlock.LegalEntities, 'TitleEN'), ', ');
            $scope.ctxtCtrl.locations = _.join(_.map($scope.procedure.MetadataBlock.Locations, 'TitleEN'), ', ');
            $scope.ctxtCtrl.langAttr = _.find(sectionBlockLookups.Language.LookupAttributeValues, { Value: 'EN' });
            $scope.ctxtCtrl.metadataToReview =
                _.startsWith(_.get($scope, 'procedure.MetadataBlock.ProgressStatus.Value', null), 'Review')
                && $scope.procedure.MetadataBlock.ReviewRequesterID !== $scope.authenticatedUser.ItemPersonID;
            initSectionBlocks();
            $scope.ctxtCtrl.canPublish = $scope.procedure.HasProcedure_Edit && $scope.procedure.CanBePublished;
        }

        function initSectionBlocks() {
            $scope.ctxtCtrl.sectionsToRequestReview = [];

            // Set flags
            _.map($scope.procedure.SectionBlocks, initSectionBlock);

        }

        function initSectionBlock(section) {
            section._isEditing = false;

            var progressStatus = _.get(section, 'ProgressStatus.Value', null);
            section._isEditable = $scope.canEditProcedure
                && (progressStatus === 'Draft' || progressStatus === 'Published');
            section._isToReview = progressStatus === 'ReviewUpdate' || progressStatus === 'ReviewCreation';
            section._isToDelete = progressStatus === 'ReviewDeletion';
            section._isApproved = progressStatus === 'Approved';
            section._isPublished = progressStatus === 'Published';
            section._isReviewer = section.ReviewRequesterID === $scope.authenticatedUser.ItemPersonID;
            section._canRequestReview = calcCanRequestReviewSection(section);
            section._canApproveReview = $scope.procedure.HasProcedure_Review && !section._isReviewer;

            updateRequestReviewForSection(section);
        }

        function calcCanRequestReviewSection(section) {
            return $scope.procedure.HasProcedure_Review
                && section._isEditable
                && _.get(section, 'ProgressStatus.Value', null) === 'Draft';
        }

        function updateRequestReviewForSection(section) {
            if (!section.SectionBlockID) return;

            var inRequestReviewListIdx = _.findIndex($scope.ctxtCtrl.sectionsToRequestReview, { SectionBlockID: section.SectionBlockID });

            if (inRequestReviewListIdx < 0 && $scope.canRequestReviewSection(section)) {
                $scope.ctxtCtrl.sectionsToRequestReview.push(section);
            } else if (!$scope.canRequestReviewSection(section)) {
                _.pullAt($scope.ctxtCtrl.sectionsToRequestReview, inRequestReviewListIdx);
            }
        }

        function updateSectionBlockLevel(sectionBlock, newLevel, $event) {
            if ($scope.ctxtCtrl.isEditing) {
                $scope.cancelEdition();
            }
            $event.stopPropagation();
            $scope.ctxtCtrl.isEditing = true;
            $scope.ctxtCtrl.hasSectionChanged = true;

            sectionBlock.Depth = newLevel;

            procedureService
              .updateSectionBlock(
                $scope.procedure.MetadataBlock.ProcedureType.Value, $scope.procedure.ProcedureID, sectionBlock)
              .then(function () {
                updateSectionListOrder();
              }, function () {
                $scope.ctxtCtrl.isEditing = false;
                $scope.ctxtCtrl.hasSectionChanged = false;
              });
        }

        function updateSectionListOrder() {
            $scope.ctxtCtrl.isEditing = true;
            $scope.ctxtCtrl.hasSectionChanged = true;

            procedureService
                .orderSectionBlocks(
                    $scope.procedure.MetadataBlock.ProcedureType.Value,
                    $scope.procedure.ProcedureID,
                    getSectionBlockListIds())
                .then(function (updatedProcedure) {
                    $scope.procedure = updatedProcedure;
                    initSectionBlocks();
                })
                .finally(function () {
                    $scope.ctxtCtrl.isEditing = false;
                    $scope.ctxtCtrl.hasSectionChanged = false;
                });
        }

        function getSectionBlockListIds() {
            return _.map($scope.procedure.SectionBlocks, 'SectionBlockID');
        }

        /**
         * Finds the next sibling's index in the list.
         * This allows to find the next spot to insert a child or find
         * the list of children to move when moving a parent and its children
         * @param sectionBlock {SectionBlock} current section block
         * @return {number} index in the list of Section Blocks of the next sibling, -1 if none
         */
        function getNextSiblingIndex(sectionBlock) {
            var curIndex = _.findIndex($scope.procedure.SectionBlocks, { 'SectionBlockID': sectionBlock.SectionBlockID });

            return _.findIndex($scope.procedure.SectionBlocks, function (sBlock) {
                return sBlock.Depth <= sectionBlock.Depth;
            }, curIndex + 1);
        }

        function scrollEditedSectionIntoView() {
            $timeout(function () {
                $scope.scrollToSection(
                    _.find($scope.procedure.SectionBlocks, {
                        _isEditing: true
                    }),
                    40); // 40 -> language switcher
            })
        }

        function openReviewModal(sectionBlock) {
            var modalScope = $scope.$new();
            var modal;

            modalScope.action = sectionBlock.ProgressStatus.Value;
            modalScope.canApproveReview = sectionBlock._canApproveReview;
            modalScope.isLoading = false;

            // Close Modal
            modalScope.close = function () {
                modal.$promise.then(modal.hide);
            };

            // Cancel Review
            modalScope.cancelReview = function () {
                if (modalScope.isLoading) return;

                modalScope.isLoading = true;
                procedureService
                    .cancelReviewSectionBlock(
                        $scope.procedure.MetadataBlock.ProcedureType.Value,
                        $scope.procedure.ProcedureID,
                        sectionBlock.SectionBlockID)
                    .then(function (updatedSectionBlock) {
                        var idx = _.findIndex($scope.procedure.SectionBlocks, {
                            SectionBlockID: updatedSectionBlock.SectionBlockID
                        });
                        $scope.procedure.SectionBlocks[idx] = updatedSectionBlock;
                        initSectionBlock(updatedSectionBlock);

                        modalScope.close();
                    })
                    .finally(function () {
                        modalScope.isLoading = false;
                    });
            };

            // Approve Review
            modalScope.approveReview = function () {
                if (modalScope.isLoading) return;

                modalScope.isLoading = true;

                if (modalScope.action === 'ReviewDeletion') {
                    procedureService
                        .checkIfCanSafelyDeleteSectionBlock(
                            $scope.procedure.MetadataBlock.ProcedureType.Value,
                            sectionBlock.SectionBlockID
                        )
                        .then(function (references) {
                            if (references.length) {
                                displayCannotDeleteModal(references);

                                return $q.reject();
                            }

                            return procedureService
                                    .approveReviewSectionBlock(
                                        $scope.procedure.MetadataBlock.ProcedureType.Value,
                                        $scope.procedure.ProcedureID,
                                        sectionBlock.SectionBlockID)
                        })
                        .then(function () {
                            window.location.reload()
                        })
                        .finally(function () {
                            modalScope.isLoading = false;
                        });
                }
                else {
                    procedureService
                        .approveReviewSectionBlock(
                            $scope.procedure.MetadataBlock.ProcedureType.Value,
                            $scope.procedure.ProcedureID,
                            sectionBlock.SectionBlockID)
                        .then(function (updatedSectionBlock) {
                            var idx = _.findIndex($scope.procedure.SectionBlocks, {
                                SectionBlockID: updatedSectionBlock.SectionBlockID
                            });

                            $scope.procedure.SectionBlocks[idx] = updatedSectionBlock;

                            notificationService.notify('Paragraph reviewed successfully');
                            initSectionBlock(updatedSectionBlock);
                            return procedureService.getProcedureForEdit($scope.procedure.MetadataBlock.ProcedureType.Value, $scope.procedure.MetadataBlock.ProcedureCode.Code);
                        })
                        .then(function (updatedProcedure) {
                            $scope.ctxtCtrl.canPublish = updatedProcedure.HasProcedure_Edit && updatedProcedure.CanBePublished;
                            modalScope.close();
                        })
                        .finally(function () {
                            modalScope.isLoading = false;
                        });
                }
            };

            // Get versions to compare
            procedureService
                .compareSectionBlock(
                    $scope.procedure.MetadataBlock.ProcedureType.Value,
                    $scope.procedure.ProcedureID,
                    sectionBlock.SectionBlockID)
                .then(function (blocksToCompare) {
                    modalScope.diff = blocksToCompare.Diff;
                    modalScope.previous = blocksToCompare.Previous;
                    modalScope.next = blocksToCompare.Next;
                    modalScope.isComparing = modalScope.previous && modalScope.next;

                    modal = $modal({
                        scope: modalScope,
                        template: '/app/Main/procedure/sectionBlock/procedureSectionReview.modal.tpl.html',
                        placement: 'center'
                    });
                });
        }

        function displayCannotDeleteModal(references) {
            modalService.displayTemplateModal(
                'References to this Procedure',
                require('../../shared/procedure/prcCannotDeleteProcedure.modal.tpl.html'),
                {
                    ngStyle: {
                        'min-height': '0'
                    },
                    references: references,
                    getUrl: function (reference) {
                        return '/Procedure/'
                            + reference.ProcedureTypeValue
                            + '/' + reference.ProcedureCodeFull
                            + '/Published#' + reference.Anchor
                    }
                },
                true,
                false
            );
        }

        init();
    }
})();
